'use client';
import { styled } from '@mui/material/styles';
import MuiTabs, { TabsProps } from '@mui/material/Tabs';
import MuiTab, { TabProps } from '@mui/material/Tab';

const StyledTabs = styled(MuiTabs)<TabsProps>({});
const StyledTab = styled(MuiTab)<TabProps>({});

export const Tabs = (props: TabsProps) => <StyledTabs {...props} />;
export const Tab = (props: TabProps) => <StyledTab {...props} />;
